export interface Environment {
  id: string;
  name: string;
}

export const environments = [
  { id: 'dev2', name: 'Dev2' },
  { id: 'dev', name: 'Dev' },
  { id: 'qa', name: 'QA' },
  { id: 'staging', name: 'Staging' },
  { id: 'master', name: 'Production' },
];